import React from "react";
import { ApplicationV2 } from "../../../main/models/application-v2";
import ApplicationButton from "../applicationButton/applicationButton";
import "./actorApplicationList.scss";

interface ActorApplicationListProps {
  setActiveApplication: (application: ApplicationV2) => void;
  activeApplication?: ApplicationV2;
  applications?: ApplicationV2[];
}

const ActorApplicationList = ({ setActiveApplication, activeApplication, applications }: ActorApplicationListProps) => (
  <div className="ApplicationList">
    {applications &&
      applications.map((application) => (
        <ApplicationButton
          key={`app-${application.id}`}
          setActiveApplication={setActiveApplication}
          activeApplication={activeApplication}
          application={application}
        />
      ))}
  </div>
);

export default ActorApplicationList;
